export default {
  getStore: (state) => state.store,
  getStores: (state) => state.stores,
  getStoresMap: (state) => {
    return state.stores?.reduce((prev, next) => {
      const { id } = next;
      prev[id] = next;
      return prev;
    }, {});
  },
};
